module.exports = __webpack_public_path__ + "img/general.144ccf66.png";